module.exports = __webpack_public_path__ + "static/media/LogoLMU.3414bd92.jpg";